import ReimbursementForm from "../../components/reimbursements/ReimbursementForm";


export default function ReimbursementAddPage () {
    return(<ReimbursementForm/>);
}